// extracted by mini-css-extract-plugin
export default {"auth__wrapper":"styles_auth__wrapper__x6lPB"};